var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["ui-input", _vm.classList], on: { click: _vm.focus } },
    [
      _vm.label
        ? _c("label", [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "ui-input-input" },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.$slots.prepend
              ? _c(
                  "div",
                  { staticClass: "ui-input-prepend" },
                  [_vm._t("prepend")],
                  2
                )
              : _vm._e()
          ]),
          _c(
            "input",
            _vm._b(
              {
                ref: "input",
                attrs: {
                  autocomplete: _vm.autocomplete !== "on" && "nope",
                  disabled: _vm.disabled,
                  readonly: _vm.readonly
                },
                domProps: { value: _vm.computedValue },
                on: {
                  input: function($event) {
                    return _vm.update($event.target.value)
                  },
                  keydown: _vm.onKeyDown,
                  focus: _vm.onFocus,
                  blur: _vm.onBlur
                }
              },
              "input",
              _vm.$attrs,
              false
            )
          ),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.loading
                ? _c("ui-loader")
                : _vm.showClear
                ? _c(
                    "div",
                    {
                      staticClass: "ui-input-append",
                      on: { click: _vm.clear }
                    },
                    [
                      _c("f-sprite-icon", {
                        attrs: { "icon-link": _vm.$options.icons.IconClose.id }
                      })
                    ],
                    1
                  )
                : _vm.$slots.append
                ? _c(
                    "div",
                    { staticClass: "ui-input-append" },
                    [_vm._t("append")],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm.$slots.error
        ? _c("p", { staticClass: "error" }, [_vm._t("error")], 2)
        : _vm.computedError && _vm.computedError.length
        ? _c("p", { staticClass: "error" }, [
            _vm._v("\n    " + _vm._s(_vm.computedError) + "\n  ")
          ])
        : _vm._e(),
      _vm._t("after")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }